/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type ApplicationAddRedirectUriRequest,
    ApplicationAddRedirectUriRequestFromJSON,
    ApplicationAddRedirectUriRequestToJSON,
} from '../models/ApplicationAddRedirectUriRequest';
import {
    type ApplicationConsumptionResponse,
    ApplicationConsumptionResponseFromJSON,
    ApplicationConsumptionResponseToJSON,
} from '../models/ApplicationConsumptionResponse';
import {
    type ApplicationCreateRequest,
    ApplicationCreateRequestFromJSON,
    ApplicationCreateRequestToJSON,
} from '../models/ApplicationCreateRequest';
import {
    type ApplicationCreateSecretRequest,
    ApplicationCreateSecretRequestFromJSON,
    ApplicationCreateSecretRequestToJSON,
} from '../models/ApplicationCreateSecretRequest';
import {
    type ApplicationRemoveRedirectUriRequest,
    ApplicationRemoveRedirectUriRequestFromJSON,
    ApplicationRemoveRedirectUriRequestToJSON,
} from '../models/ApplicationRemoveRedirectUriRequest';
import {
    type ApplicationRemoveSecretRequest,
    ApplicationRemoveSecretRequestFromJSON,
    ApplicationRemoveSecretRequestToJSON,
} from '../models/ApplicationRemoveSecretRequest';
import {
    type ApplicationResponse,
    ApplicationResponseFromJSON,
    ApplicationResponseToJSON,
} from '../models/ApplicationResponse';
import {
    type ApplicationResponsePagedResult,
    ApplicationResponsePagedResultFromJSON,
    ApplicationResponsePagedResultToJSON,
} from '../models/ApplicationResponsePagedResult';
import {
    type ApplicationResponsiblePersonResponse,
    ApplicationResponsiblePersonResponseFromJSON,
    ApplicationResponsiblePersonResponseToJSON,
} from '../models/ApplicationResponsiblePersonResponse';
import {
    type ApplicationResponsiblePersonResponsePagedResult,
    ApplicationResponsiblePersonResponsePagedResultFromJSON,
    ApplicationResponsiblePersonResponsePagedResultToJSON,
} from '../models/ApplicationResponsiblePersonResponsePagedResult';
import {
    type ApplicationResponsiblePersonSearchRequest,
    ApplicationResponsiblePersonSearchRequestFromJSON,
    ApplicationResponsiblePersonSearchRequestToJSON,
} from '../models/ApplicationResponsiblePersonSearchRequest';
import {
    type ApplicationSearchOrderBy,
    ApplicationSearchOrderByFromJSON,
    ApplicationSearchOrderByToJSON,
} from '../models/ApplicationSearchOrderBy';
import {
    type ApplicationUpdateRequest,
    ApplicationUpdateRequestFromJSON,
    ApplicationUpdateRequestToJSON,
} from '../models/ApplicationUpdateRequest';
import {
    type ClientSecretResponse,
    ClientSecretResponseFromJSON,
    ClientSecretResponseToJSON,
} from '../models/ClientSecretResponse';
import {
    type GenericValidationError,
    GenericValidationErrorFromJSON,
    GenericValidationErrorToJSON,
} from '../models/GenericValidationError';
import {
    type NotFoundResult,
    NotFoundResultFromJSON,
    NotFoundResultToJSON,
} from '../models/NotFoundResult';
import {
    type ResourceFilter,
    ResourceFilterFromJSON,
    ResourceFilterToJSON,
} from '../models/ResourceFilter';
import {
    type SortOrder,
    SortOrderFromJSON,
    SortOrderToJSON,
} from '../models/SortOrder';

export interface ApiApplicationsApplicationIdApplicationCredentialDeleteRequest {
    applicationId: string;
    applicationRemoveSecretRequest: ApplicationRemoveSecretRequest;
}

export interface ApiApplicationsApplicationIdApplicationCredentialPostRequest {
    applicationId: string;
    applicationCreateSecretRequest: ApplicationCreateSecretRequest;
}

export interface ApiApplicationsApplicationIdRedirecturiDeleteRequest {
    applicationId: string;
    applicationRemoveRedirectUriRequest: ApplicationRemoveRedirectUriRequest;
}

export interface ApiApplicationsApplicationIdRedirecturiPostRequest {
    applicationId: string;
    applicationAddRedirectUriRequest: ApplicationAddRedirectUriRequest;
}

export interface ApiApplicationsApplicationResponsiblePersonsActivePostRequest {
    applicationResponsiblePersonSearchRequest: ApplicationResponsiblePersonSearchRequest;
}

export interface ApiApplicationsCheckusageGetRequest {
    id?: string;
}

export interface ApiApplicationsGetRequest {
    pageNumber?: any;
    pageSize?: any;
    sortOrder?: SortOrder;
    orderField?: ApplicationSearchOrderBy;
    userId?: string;
    resourceFilter?: ResourceFilter;
}

export interface ApiApplicationsIdDeleteRequest {
    id: string;
}

export interface ApiApplicationsIdPutRequest {
    id: string;
    applicationUpdateRequest: ApplicationUpdateRequest;
}

export interface ApiApplicationsIdUnlockExternalApproverSupportPutRequest {
    id: string;
}

export interface ApiApplicationsPostRequest {
    applicationCreateRequest: ApplicationCreateRequest;
}

export interface GetApplicationByIdRequest {
    id: string;
}

/**
 * 
 */
export class ApplicationsApi extends runtime.BaseAPI {

    /**
     * Creates request options for apiApplicationsApplicationIdApplicationCredentialDelete without sending the request
     */
    async apiApplicationsApplicationIdApplicationCredentialDeleteRequestOpts(requestParameters: ApiApplicationsApplicationIdApplicationCredentialDeleteRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['applicationId'] == null) {
            throw new runtime.RequiredError(
                'applicationId',
                'Required parameter "applicationId" was null or undefined when calling apiApplicationsApplicationIdApplicationCredentialDelete().'
            );
        }

        if (requestParameters['applicationRemoveSecretRequest'] == null) {
            throw new runtime.RequiredError(
                'applicationRemoveSecretRequest',
                'Required parameter "applicationRemoveSecretRequest" was null or undefined when calling apiApplicationsApplicationIdApplicationCredentialDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/applications/{applicationId}/application-credential`;
        urlPath = urlPath.replace('{applicationId}', encodeURIComponent(String(requestParameters['applicationId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: ApplicationRemoveSecretRequestToJSON(requestParameters['applicationRemoveSecretRequest']),
        };
    }

    /**
     */
    async apiApplicationsApplicationIdApplicationCredentialDeleteRaw(requestParameters: ApiApplicationsApplicationIdApplicationCredentialDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.apiApplicationsApplicationIdApplicationCredentialDeleteRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiApplicationsApplicationIdApplicationCredentialDelete(requestParameters: ApiApplicationsApplicationIdApplicationCredentialDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiApplicationsApplicationIdApplicationCredentialDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for apiApplicationsApplicationIdApplicationCredentialPost without sending the request
     */
    async apiApplicationsApplicationIdApplicationCredentialPostRequestOpts(requestParameters: ApiApplicationsApplicationIdApplicationCredentialPostRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['applicationId'] == null) {
            throw new runtime.RequiredError(
                'applicationId',
                'Required parameter "applicationId" was null or undefined when calling apiApplicationsApplicationIdApplicationCredentialPost().'
            );
        }

        if (requestParameters['applicationCreateSecretRequest'] == null) {
            throw new runtime.RequiredError(
                'applicationCreateSecretRequest',
                'Required parameter "applicationCreateSecretRequest" was null or undefined when calling apiApplicationsApplicationIdApplicationCredentialPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/applications/{applicationId}/application-credential`;
        urlPath = urlPath.replace('{applicationId}', encodeURIComponent(String(requestParameters['applicationId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApplicationCreateSecretRequestToJSON(requestParameters['applicationCreateSecretRequest']),
        };
    }

    /**
     */
    async apiApplicationsApplicationIdApplicationCredentialPostRaw(requestParameters: ApiApplicationsApplicationIdApplicationCredentialPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClientSecretResponse>> {
        const requestOptions = await this.apiApplicationsApplicationIdApplicationCredentialPostRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClientSecretResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiApplicationsApplicationIdApplicationCredentialPost(requestParameters: ApiApplicationsApplicationIdApplicationCredentialPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClientSecretResponse> {
        const response = await this.apiApplicationsApplicationIdApplicationCredentialPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for apiApplicationsApplicationIdRedirecturiDelete without sending the request
     */
    async apiApplicationsApplicationIdRedirecturiDeleteRequestOpts(requestParameters: ApiApplicationsApplicationIdRedirecturiDeleteRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['applicationId'] == null) {
            throw new runtime.RequiredError(
                'applicationId',
                'Required parameter "applicationId" was null or undefined when calling apiApplicationsApplicationIdRedirecturiDelete().'
            );
        }

        if (requestParameters['applicationRemoveRedirectUriRequest'] == null) {
            throw new runtime.RequiredError(
                'applicationRemoveRedirectUriRequest',
                'Required parameter "applicationRemoveRedirectUriRequest" was null or undefined when calling apiApplicationsApplicationIdRedirecturiDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/applications/{applicationId}/redirecturi`;
        urlPath = urlPath.replace('{applicationId}', encodeURIComponent(String(requestParameters['applicationId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: ApplicationRemoveRedirectUriRequestToJSON(requestParameters['applicationRemoveRedirectUriRequest']),
        };
    }

    /**
     */
    async apiApplicationsApplicationIdRedirecturiDeleteRaw(requestParameters: ApiApplicationsApplicationIdRedirecturiDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.apiApplicationsApplicationIdRedirecturiDeleteRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiApplicationsApplicationIdRedirecturiDelete(requestParameters: ApiApplicationsApplicationIdRedirecturiDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiApplicationsApplicationIdRedirecturiDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for apiApplicationsApplicationIdRedirecturiPost without sending the request
     */
    async apiApplicationsApplicationIdRedirecturiPostRequestOpts(requestParameters: ApiApplicationsApplicationIdRedirecturiPostRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['applicationId'] == null) {
            throw new runtime.RequiredError(
                'applicationId',
                'Required parameter "applicationId" was null or undefined when calling apiApplicationsApplicationIdRedirecturiPost().'
            );
        }

        if (requestParameters['applicationAddRedirectUriRequest'] == null) {
            throw new runtime.RequiredError(
                'applicationAddRedirectUriRequest',
                'Required parameter "applicationAddRedirectUriRequest" was null or undefined when calling apiApplicationsApplicationIdRedirecturiPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/applications/{applicationId}/redirecturi`;
        urlPath = urlPath.replace('{applicationId}', encodeURIComponent(String(requestParameters['applicationId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApplicationAddRedirectUriRequestToJSON(requestParameters['applicationAddRedirectUriRequest']),
        };
    }

    /**
     */
    async apiApplicationsApplicationIdRedirecturiPostRaw(requestParameters: ApiApplicationsApplicationIdRedirecturiPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApplicationResponse>> {
        const requestOptions = await this.apiApplicationsApplicationIdRedirecturiPostRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApplicationResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiApplicationsApplicationIdRedirecturiPost(requestParameters: ApiApplicationsApplicationIdRedirecturiPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApplicationResponse> {
        const response = await this.apiApplicationsApplicationIdRedirecturiPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for apiApplicationsApplicationResponsiblePersonsActivePost without sending the request
     */
    async apiApplicationsApplicationResponsiblePersonsActivePostRequestOpts(requestParameters: ApiApplicationsApplicationResponsiblePersonsActivePostRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['applicationResponsiblePersonSearchRequest'] == null) {
            throw new runtime.RequiredError(
                'applicationResponsiblePersonSearchRequest',
                'Required parameter "applicationResponsiblePersonSearchRequest" was null or undefined when calling apiApplicationsApplicationResponsiblePersonsActivePost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/applications/application-responsible-persons/active`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApplicationResponsiblePersonSearchRequestToJSON(requestParameters['applicationResponsiblePersonSearchRequest']),
        };
    }

    /**
     */
    async apiApplicationsApplicationResponsiblePersonsActivePostRaw(requestParameters: ApiApplicationsApplicationResponsiblePersonsActivePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApplicationResponsiblePersonResponsePagedResult>> {
        const requestOptions = await this.apiApplicationsApplicationResponsiblePersonsActivePostRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApplicationResponsiblePersonResponsePagedResultFromJSON(jsonValue));
    }

    /**
     */
    async apiApplicationsApplicationResponsiblePersonsActivePost(requestParameters: ApiApplicationsApplicationResponsiblePersonsActivePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApplicationResponsiblePersonResponsePagedResult> {
        const response = await this.apiApplicationsApplicationResponsiblePersonsActivePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for apiApplicationsApplicationResponsiblePersonsCandidatesGet without sending the request
     */
    async apiApplicationsApplicationResponsiblePersonsCandidatesGetRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/applications/application-responsible-persons/candidates`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiApplicationsApplicationResponsiblePersonsCandidatesGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ApplicationResponsiblePersonResponse>>> {
        const requestOptions = await this.apiApplicationsApplicationResponsiblePersonsCandidatesGetRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ApplicationResponsiblePersonResponseFromJSON));
    }

    /**
     */
    async apiApplicationsApplicationResponsiblePersonsCandidatesGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ApplicationResponsiblePersonResponse>> {
        const response = await this.apiApplicationsApplicationResponsiblePersonsCandidatesGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for apiApplicationsCheckusageGet without sending the request
     */
    async apiApplicationsCheckusageGetRequestOpts(requestParameters: ApiApplicationsCheckusageGetRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/applications/checkusage`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiApplicationsCheckusageGetRaw(requestParameters: ApiApplicationsCheckusageGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApplicationConsumptionResponse>> {
        const requestOptions = await this.apiApplicationsCheckusageGetRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApplicationConsumptionResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiApplicationsCheckusageGet(requestParameters: ApiApplicationsCheckusageGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApplicationConsumptionResponse> {
        const response = await this.apiApplicationsCheckusageGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for apiApplicationsGet without sending the request
     */
    async apiApplicationsGetRequestOpts(requestParameters: ApiApplicationsGetRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['pageNumber'] != null) {
            queryParameters['PageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['PageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortOrder'] != null) {
            queryParameters['SortOrder'] = requestParameters['sortOrder'];
        }

        if (requestParameters['orderField'] != null) {
            queryParameters['OrderField'] = requestParameters['orderField'];
        }

        if (requestParameters['userId'] != null) {
            queryParameters['UserId'] = requestParameters['userId'];
        }

        if (requestParameters['resourceFilter'] != null) {
            queryParameters['ResourceFilter'] = requestParameters['resourceFilter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/applications`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiApplicationsGetRaw(requestParameters: ApiApplicationsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApplicationResponsePagedResult>> {
        const requestOptions = await this.apiApplicationsGetRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApplicationResponsePagedResultFromJSON(jsonValue));
    }

    /**
     */
    async apiApplicationsGet(requestParameters: ApiApplicationsGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApplicationResponsePagedResult> {
        const response = await this.apiApplicationsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for apiApplicationsIdDelete without sending the request
     */
    async apiApplicationsIdDeleteRequestOpts(requestParameters: ApiApplicationsIdDeleteRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiApplicationsIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/applications/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiApplicationsIdDeleteRaw(requestParameters: ApiApplicationsIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.apiApplicationsIdDeleteRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiApplicationsIdDelete(requestParameters: ApiApplicationsIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiApplicationsIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for apiApplicationsIdPut without sending the request
     */
    async apiApplicationsIdPutRequestOpts(requestParameters: ApiApplicationsIdPutRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiApplicationsIdPut().'
            );
        }

        if (requestParameters['applicationUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'applicationUpdateRequest',
                'Required parameter "applicationUpdateRequest" was null or undefined when calling apiApplicationsIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/applications/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ApplicationUpdateRequestToJSON(requestParameters['applicationUpdateRequest']),
        };
    }

    /**
     */
    async apiApplicationsIdPutRaw(requestParameters: ApiApplicationsIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApplicationResponse>> {
        const requestOptions = await this.apiApplicationsIdPutRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApplicationResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiApplicationsIdPut(requestParameters: ApiApplicationsIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApplicationResponse> {
        const response = await this.apiApplicationsIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for apiApplicationsIdUnlockExternalApproverSupportPut without sending the request
     */
    async apiApplicationsIdUnlockExternalApproverSupportPutRequestOpts(requestParameters: ApiApplicationsIdUnlockExternalApproverSupportPutRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiApplicationsIdUnlockExternalApproverSupportPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/applications/{id}/unlock-external-approver-support`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiApplicationsIdUnlockExternalApproverSupportPutRaw(requestParameters: ApiApplicationsIdUnlockExternalApproverSupportPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.apiApplicationsIdUnlockExternalApproverSupportPutRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiApplicationsIdUnlockExternalApproverSupportPut(requestParameters: ApiApplicationsIdUnlockExternalApproverSupportPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiApplicationsIdUnlockExternalApproverSupportPutRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for apiApplicationsPost without sending the request
     */
    async apiApplicationsPostRequestOpts(requestParameters: ApiApplicationsPostRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['applicationCreateRequest'] == null) {
            throw new runtime.RequiredError(
                'applicationCreateRequest',
                'Required parameter "applicationCreateRequest" was null or undefined when calling apiApplicationsPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/applications`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApplicationCreateRequestToJSON(requestParameters['applicationCreateRequest']),
        };
    }

    /**
     */
    async apiApplicationsPostRaw(requestParameters: ApiApplicationsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApplicationResponse>> {
        const requestOptions = await this.apiApplicationsPostRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApplicationResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiApplicationsPost(requestParameters: ApiApplicationsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApplicationResponse> {
        const response = await this.apiApplicationsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getApplicationById without sending the request
     */
    async getApplicationByIdRequestOpts(requestParameters: GetApplicationByIdRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getApplicationById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/applications/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getApplicationByIdRaw(requestParameters: GetApplicationByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApplicationResponse>> {
        const requestOptions = await this.getApplicationByIdRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApplicationResponseFromJSON(jsonValue));
    }

    /**
     */
    async getApplicationById(requestParameters: GetApplicationByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApplicationResponse> {
        const response = await this.getApplicationByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
